import { render, staticRenderFns } from "./ProfilingCreatePage.vue?vue&type=template&id=1af07c2a&lang=pug"
import script from "./ProfilingCreatePage.vue?vue&type=script&lang=js"
export * from "./ProfilingCreatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1af07c2a')) {
      api.createRecord('1af07c2a', component.options)
    } else {
      api.reload('1af07c2a', component.options)
    }
    module.hot.accept("./ProfilingCreatePage.vue?vue&type=template&id=1af07c2a&lang=pug", function () {
      api.rerender('1af07c2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/data_quality_dataplex/ProfilingCreatePage.vue"
export default component.exports